import React from 'react';
import { useLanguage } from '../../../shared/contexts/LanguageContext';
import useTranslation from '../../../shared/hooks/useTranslation';

interface NotificationBannerProps {
  type: 'maintenance' | 'scheduled' | 'deletion';
  message?: string;
  scheduledAt?: string;
  scheduledMessage?: string;
}

const NotificationBanner: React.FC<NotificationBannerProps> = ({
  type,
  message,
  scheduledAt,
  scheduledMessage,
}) => {
  const { language } = useLanguage();
  const { t } = useTranslation(language);
  if (type === 'maintenance') {
    return (
      <div className="fixed top-0 left-0 right-0 bg-orange-900/90 backdrop-blur-md border-b-2 border-orange-500/50 z-40 notification-game">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center gap-4">
          <i className="fas fa-tools text-orange-400 text-2xl animate-pulse"></i>
          <div>
            <h3 className="text-lg font-bold text-orange-200 mb-1">🔧 {t('notifications.maintenance.title')}</h3>
            <p className="text-orange-300 text-sm">
              {message || t('notifications.maintenance.message')}
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (type === 'scheduled') {
    return (
      <div className="fixed top-0 left-0 right-0 bg-yellow-900/90 backdrop-blur-md border-b-2 border-yellow-500/50 z-40 notification-game">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center gap-4">
          <i className="fas fa-calendar-alt text-yellow-400 text-2xl animate-pulse"></i>
          <div className="flex-1">
            <h3 className="text-lg font-bold text-yellow-200 mb-1">📅 {t('notifications.scheduled.title')}</h3>
            <p className="text-yellow-300 text-sm">
              {scheduledMessage || t('notifications.scheduled.message')}
              {scheduledAt && (
                <>
                  {' '}
                  <strong>
                    {new Date(scheduledAt).toLocaleString('fr-FR', {
                      day: 'numeric',
                      month: 'long',
                      year: 'numeric',
                      hour: '2-digit',
                      minute: '2-digit',
                    })}
                  </strong>
                </>
              )}
            </p>
          </div>
        </div>
      </div>
    );
  }

  if (type === 'deletion') {
    return (
      <div className="fixed top-0 left-0 right-0 bg-green-900/90 backdrop-blur-md border-b-2 border-green-500/50 z-40 notification-game">
        <div className="max-w-7xl mx-auto px-6 py-4 flex items-center gap-4">
          <i className="fas fa-check-circle text-green-400 text-2xl"></i>
          <div>
            <h3 className="text-lg font-bold text-green-200 mb-1">{t('notifications.deletion.title')}</h3>
            <p className="text-green-300 text-sm">
              {t('notifications.deletion.message')}
            </p>
          </div>
        </div>
      </div>
    );
  }

  return null;
};

export default NotificationBanner;

